import React from 'react';

import { CrossmarkIcon } from 'assets/icons';
import { IconWrapper, TagContainer, TagLabel } from 'common/components/Tag/Tag.styled';
import { useTheme } from 'styled-components';

interface TagProps {
  label: string;
  onRemove?: () => void;
}

export const Tag = ({ label, onRemove }: TagProps) => {
  const { colors } = useTheme();

  return (
    <TagContainer>
      <TagLabel>{label}</TagLabel>
      {onRemove && (
        <IconWrapper onClick={onRemove}>
          <CrossmarkIcon width={16} height={16} fill={colors.white} stroke={colors.white} />
        </IconWrapper>
      )}
    </TagContainer>
  );
};
